export class SessionError extends Error {

  constructor(message: any) {
      super(message);
      this.name = 'SessionError';
  }

}
